
webpack.register(
    'blocks/leaderboard-drawer/media-feed/media-feed',
    function() {
        return import('blocks/leaderboard-drawer/media-feed/media-feed');
    },
    true
);